// ===== PubSub Optimizado =====
// Sistema leve de publicação/assinatura de eventos
// Usado para comunicação entre componentes Shopify (variantChange, cartUpdate etc.)
window.subscribers = window.subscribers || Object.create(null);

function subscribe(eventName, callback) {
  if (!subscribers[eventName]) subscribers[eventName] = [];

  subscribers[eventName].push(callback);

  // Retorna função para cancelar inscrição
  return function unsubscribe() {
    const arr = subscribers[eventName];
    if (!arr) return;
    const index = arr.indexOf(callback);
    if (index > -1) arr.splice(index, 1);
  };
}

function publish(eventName, data) {
  const arr = subscribers[eventName];
  if (!arr || arr.length === 0) return;

  for (let i = 0; i < arr.length; i++) {
    try {
      arr[i](data);
    } catch (err) {
      // Evita quebra total se algum callback falhar
      console.warn(`Erro no callback de "${eventName}":`, err);
    }
  }
}

// Exporta globalmente (compatível com scripts Shopify)
window.subscribe = subscribe;
window.publish = publish;
